/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { BREAKPOINTS } from '../../spacing/index.js';
import BrandLogo from './BrandLogo.js';
import MobileMenu from './MobileMenu.js';
import SideNavContext from './SideNavContext.js';
import { MainNavWrapper, MainNavList } from './styledComponents.js';
import { renderSelectedTabContent } from './utils.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';
import useNavigation from '../../hooks/useNavigation.js';
import useMedia from '../../hooks/useMedia.js';

var MainNav = function MainNav(_ref) {
  var children = _ref.children,
    mainNavRef = _ref.mainNavRef;
  var theme = useTheme();
  var _useNavigation = useNavigation(),
    mainNavWrapperRef = _useNavigation.mainNavWrapperRef;
  var _useContext = useContext(SideNavContext),
    brandLogoProps = _useContext.brandLogoProps,
    isWideMainNav = _useContext.isWideMainNav,
    mobileTabs = _useContext.mobileTabs,
    selectedTab = _useContext.selectedTab;
  var showHamburgerMenu = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")],
  // media queries
  [true],
  // values corresponding to media query
  false // default value
  );
  if (showHamburgerMenu) {
    return /*#__PURE__*/jsx(MobileMenu, {
      children: children
    });
  }
  return /*#__PURE__*/jsxs(MainNavWrapper, {
    ref: mainNavWrapperRef,
    "data-testid": "main-nav",
    isWideMainNav: isWideMainNav,
    theme: theme,
    children: [theme.sideNav.brandLogo.showLogo && /*#__PURE__*/jsx(BrandLogo, _objectSpread({
      isWideMainNav: isWideMainNav
    }, brandLogoProps)), children && /*#__PURE__*/jsx(MainNavList, {
      theme: theme,
      children: renderSelectedTabContent(mobileTabs, selectedTab, children, mainNavRef)
    })]
  });
};
process.env.NODE_ENV !== "production" ? MainNav.propTypes = {
  children: PropTypes.node
} : undefined;
process.env.NODE_ENV !== "production" ? MainNav.displayName = 'MainNav' : undefined;

export { MainNav as default };
